import React, { Key, useEffect, useState } from 'react'
import './AppraisalsAdmin.scss'
import { Link } from 'react-router-dom'
import { Logger } from '../../../../../Helpers/Logger'
import { AppraisalPDF, HorizontalLoader, ImageSrc, ModalWrapper } from '../../../../../Components'
import Pagination from '../../../../../Components/Pagination/Pagination'
import { useForm } from 'react-hook-form'
import Swal from 'sweetalert2'
import { appraisalService } from 'Services/appraisalService'
import { AppraisalsType } from 'Models/appraisalsType'
import { TimeConverter } from 'Helpers/TimeConverter'
import { pdf } from '@react-pdf/renderer'
import { ReactComponent as DownloadSvg } from '../../../../../Assets/Images/downloadSvg.svg'
import toast from 'react-hot-toast'
import { CsvDownloaderTwo } from 'Helpers'

export type AppraisalsSettingsFormType = {
  appraisalClosingDate: Date
  appraisalQuarter: string
  appraisalYear: number
  appraisalStartingDate: Date
}

const AppraisalsAdmin = () => {
  const [pageNumber, setPage] = useState(1)

  const [loading, setLoading] = useState(false)
  const [request, setRequest] = useState(false)
  const [years, setYears] = useState<number[]>([])

  const [quarter, setQuarter] = useState<number>()

  const [year, setYear] = useState<string>()

  const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear())

  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 0,
  })

  const [appraisal, setAppraisals] = useState<AppraisalsType[]>()

  const getApraisals = async () => {
    setLoading(true)
    await appraisalService.index(pageNumber, year, quarter).then(
      (response) => {
        setLoading(false)
        // console.log('ap response', response)
        setAppraisals(response?.data.data.dataset)
        setPaginationData({
          pageNumber: Number(response?.data?.data?.pageNumber) || 1,
          pageSize: Number(response?.data?.data?.pageSize) || 50,
          total: Number(response?.data?.data?.total) || 1,
        })
      },
      (error: { response: object }) => {
        setLoading(false)
        Logger('response error', error.response)
      },
    )
  }

  useEffect(() => {
    getApraisals()
  }, [pageNumber, year, quarter])

  const [showPayslipModal, setShowPayslipModal] = useState(false)

  const togglePayslipModal = (userId?: string) => {
    setShowPayslipModal((prevState) => !prevState)
  }

  useEffect(() => {
    // Set current and future years (e.g., next 10 years)
    const currentYear = new Date().getFullYear()
    const futureYears = Array.from({ length: 10 }, (_, index) => currentYear + index)
    setYears(futureYears)
  }, [])

  const subtractOneHour = (dateTime: string | Date): Date => {
    const date = new Date(dateTime)
    // Subtract 1 hour
    date.setHours(date.getHours() + 1)
    return date
  }

  const add54Minutes = (dateTime: string | Date): Date => {
    const date = new Date(dateTime)
    // date.setMinutes(date.getMinutes() + 54);
    date.setMinutes(date.getMinutes())
    return date
  }

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<AppraisalsSettingsFormType>()

  const startAppraisal = async (data: AppraisalsSettingsFormType) => {
    setRequest(true)
    // console.log({ data })
    await appraisalService
      .startAppraisal({
        ...data,
        appraisalClosingDate: add54Minutes(data.appraisalClosingDate),
      })
      .then(
        (res) => {
          Swal.close()
          setRequest(false)
          togglePayslipModal()
          Swal.fire({
            icon: 'success',
            title: 'Completed',
            text: 'Settings saved successfully!',
          })
        },
        (error) => {
          setRequest(false)
          Swal.close()
          console.log('productService error', error.response)
          const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              cancelButton: 'btn btn-danger',
            },
            buttonsStyling: false,
          })

          swalWithBootstrapButtons.fire({
            title: 'Oops!',
            text: error.response.data.error,
            icon: 'warning',
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: 'close',
            reverseButtons: true,
          })
        },
      )
  }

  const handlePreview = async () => {
    toast.loading('Preview loading, please wait...')

    try {
      const blob = await pdf(<AppraisalPDF dataset={appraisal} />).toBlob()
      const url = URL.createObjectURL(blob)
      window.open(url, '_blank')
      toast.dismiss()
      setTimeout(() => {
        URL.revokeObjectURL(url)
      }, 10000)
    } catch (error: any) {
      console.error('PDF preview error:', error)
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })

      swalWithBootstrapButtons.fire({
        title: 'Oops!',
        text: error.response.data.error,
        icon: 'warning',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: 'close',
        reverseButtons: true,
      })
    }
  }

  const handleExport = async () => {
    toast.loading('Downloading csv, please wait...')

    try {
      const res = await appraisalService.downloadCsv()
      CsvDownloaderTwo(res.data)
      toast.dismiss()
    } catch (error: any) {
      // console.error('PDF preview error:', error)
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })

      swalWithBootstrapButtons.fire({
        title: 'Oops!',
        text: error.response.data.error,
        icon: 'warning',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: 'close',
        reverseButtons: true,
      })
    } finally {
      toast.dismiss()
    }
  }

  return (
    <div className='ApraisalAdmin'>
      <div className='container mt-4'>
        <div className='container'>
          <div className='card border-0'>
            <div className='card-header border-0 px-0 h-100'>
              <div className='row h-100'>
                <div className='col-12 col-md-5 my-auto h-100 d-flex pe-md-0'>
                  <div className='wraper h-100 my-auto'>
                    <div className='title my-auto'>All Appraisals</div>
                    <select
                      className='form-control ms-3'
                      onChange={(val) => setYear(val.target.value)}
                    >
                      <option value={''}>All Year</option>
                      <option>2024</option>
                      <option>2025</option>
                      <option>2026</option>
                      <option>2027</option>
                      <option>2028</option>
                      <option>2029</option>
                      <option>2030</option>
                      <option>2031</option>
                      <option>2032</option>
                      <option>2033</option>
                      <option>2034</option>
                      <option>2035</option>
                    </select>

                    <select
                      className='form-control ms-3'
                      onChange={(val) => setQuarter(Number(val.target.value))}
                    >
                      <option value={''}>All Quarter</option>
                      <option value={1}>Q1</option>
                      <option value={2}>Q2</option>
                      <option value={3}>Q3</option>
                      <option value={4}>Q4</option>
                    </select>
                  </div>
                </div>

                <div className='d-flex flex-wrap justify-content-end gap-2'>
                  <div className=' my-auto text-end btn-0'>
                    <button
                      className='btn btn-default btn-start-app'
                      onClick={() => togglePayslipModal(undefined)}
                    >
                      + Start New Appraisal
                    </button>
                  </div>
                  <div className='my-auto text-end btn-0 d-none'>
                    <button
                      className='btn btn-default btn-start-app btn-alt'
                      onClick={handlePreview}
                    >
                      <DownloadSvg style={{ width: '25px', height: '24px', fill: 'white' }} />
                      Preview PDF
                    </button>
                  </div>
                  <div className='d-flex flex-wrap justify-content-end gap-2 dropdown'>
                    <button
                      className='btn btn-default btn-start-app btn-alt'
                      data-bs-toggle='dropdown'
                      aria-expanded='false'
                    >
                      {/* <DownloadSvgTwo /> */}
                      <DownloadSvg style={{ width: '25px', height: '24px', fill: 'white' }} />
                      Export
                    </button>

                    <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                      <li onClick={handleExport} className='dropdown-item'>
                        {' '}
                        Export as .csv
                      </li>
                      <li onClick={handlePreview} className='dropdown-item'>
                        {' '}
                        Export as .pdf
                      </li>
                      <li className='d-none dropdown-item'> Export as .xlsx</li>
                      <li className='d-none dropdown-item'> Export as .doc </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* <div className="row mt-2">
                <div className="col-12 col-md-8">
                  <div className="search-field">
                    <span>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.675 11.5661C9.34155 13.8995 5.55835 13.8995 3.22493 11.5661C0.891523 9.23269 0.891523 5.44948 3.22493 3.11607C5.55835 0.782656 9.34156 0.782656 11.675 3.11607C14.0084 5.44948 14.0084 9.23269 11.675 11.5661ZM11.675 11.5661L16.4126 16.3037"
                          stroke="#868484"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                      </svg>
                    </span>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search Employee ID or Employee Name"
                    />
                  </div>
                </div>
                <div className="col-6 col-md-2 dropdown">
                  <button
                    className="btn btn-filter dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.94 22.65C10.46 22.65 9.99002 22.53 9.55002 22.29C8.67002 21.8 8.14002 20.91 8.14002 19.91V14.61C8.14002 14.11 7.81002 13.36 7.50002 12.98L3.76002 9.02001C3.13002 8.39001 2.65002 7.31001 2.65002 6.50001V4.20001C2.65002 2.60001 3.86002 1.35001 5.40002 1.35001H18.6C20.12 1.35001 21.35 2.58001 21.35 4.10001V6.30001C21.35 7.35001 20.72 8.54001 20.13 9.13001L15.8 12.96C15.38 13.31 15.05 14.08 15.05 14.7V19C15.05 19.89 14.49 20.92 13.79 21.34L12.41 22.23C11.96 22.51 11.45 22.65 10.94 22.65ZM5.40002 2.85001C4.70002 2.85001 4.15002 3.44001 4.15002 4.20001V6.50001C4.15002 6.87001 4.45002 7.59001 4.83002 7.97001L8.64002 11.98C9.15002 12.61 9.65002 13.66 9.65002 14.6V19.9C9.65002 20.55 10.1 20.87 10.29 20.97C10.71 21.2 11.22 21.2 11.61 20.96L13 20.07C13.28 19.9 13.56 19.36 13.56 19V14.7C13.56 13.63 14.08 12.45 14.83 11.82L19.11 8.03001C19.45 7.69001 19.86 6.88001 19.86 6.29001V4.10001C19.86 3.41001 19.3 2.85001 18.61 2.85001H5.40002Z"
                        fill="#868484"
                      />
                      <path
                        d="M6.00004 10.75C5.86004 10.75 5.73004 10.71 5.60004 10.64C5.25004 10.42 5.14004 9.94999 5.36004 9.59999L10.29 1.69999C10.51 1.34999 10.97 1.23999 11.32 1.45999C11.67 1.67999 11.78 2.13999 11.56 2.48999L6.63004 10.39C6.49004 10.62 6.25004 10.75 6.00004 10.75Z"
                        fill="#868484"
                      />
                    </svg>
                    Filters
                  </button>
                  <div className="dropdown-menu dropdown-menu-end border-0 shadow filter-dropdown">
                    <div className="dropdown-item">
                      <form action="">
                        <div className="form-group">
                          <label htmlFor="">Status</label>
                          <select id="" className="form-control">
                            <option>Active</option>
                          </select>
                        </div>
                        <div className="form-group mt-3">
                          <label htmlFor="">Depot</label>
                          <select id="" className="form-control">
                            <option>Wari</option>
                          </select>
                        </div>
                        <div className="form-group mt-3">
                          <label htmlFor="">Avail. Volume</label>
                          <select id="" className="form-control">
                            <option>All</option>
                          </select>
                        </div>

                        <div className="row mt-3">
                          <div className="col-md-6">
                            <button className="btn btn-reset">Reset</button>
                          </div>
                          <div className="col-md-6 text-end">
                            <button className="btn btn-filter">Filter</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-md-2 dropdown">
                  <button
                    className="btn btn-export dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 11V17L11 15"
                        stroke="#868484"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9 17L7 15"
                        stroke="#868484"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14"
                        stroke="#868484"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M22 10H18C15 10 14 9 14 6V2L22 10Z"
                        stroke="#868484"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>{" "}
                    Export
                  </button>

                  <ul className="dropdown-menu dropdown-menu-end export-dropdown border-0 shadow">
                    <li className="dropdown-item"> Export as .pdf</li>
                    <li className="dropdown-item"> Export as .xlsx</li>
                    <li className="dropdown-item"> Export as .doc </li>
                  </ul>
                </div>
              </div> */}
            </div>
            <div className='card-body'>
              <div className='table-responsive'>
                <table className='table'>
                  <thead>
                    <tr>
                      <td>S/N</td>
                      {/* <td>Employee ID</td> */}
                      <td>Employee Name</td>
                      {/* <td>Role</td> */}
                      <td>Line Manager</td>
                      <td>Quarter</td>
                      <td>Date</td>
                      <td>Satus</td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    {appraisal &&
                      appraisal?.length > 0 &&
                      appraisal.map((data: AppraisalsType, index: Key) => (
                        <tr key={index}>
                          <td>{Number(index) + 1}</td>
                          {/* <td>{data.employee.employeeId}</td> */}
                          <td>
                            {data.employee.firstName} {data.employee.lastName}
                          </td>
                          {/* <td>{data.employee.role}</td> */}
                          <td>{data.lineManagerEmailAddress} </td>
                          <td>Q{data.quarter}</td>
                          <td>{TimeConverter(data.createdAt)}</td>
                          <td>
                            {data.status === 'AWAITING_LINE_MANAGER_REVIEW' && (
                              <span className='status-warn'>{data.status}</span>
                            )}
                            {data.status !== 'AWAITING_LINE_MANAGER_REVIEW' && (
                              <span className='status-success'>{data.status}</span>
                            )}
                            {/* <span className="status-primary">
                              {data.status}
                            </span> */}
                          </td>
                          <td
                            className={`${data.status === 'DRAFT' ? 'disabled' : ''} dropdown option-dropdown d-inline-flex`}
                          >
                            <Link to={`/admin/appraisals-admin/${data.id}`}>
                              <button className='btn p-1'>
                                <svg
                                  width='18'
                                  height='18'
                                  viewBox='0 0 18 18'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <path
                                    d='M8.99945 12.2479C7.20695 12.2479 5.75195 10.7929 5.75195 9.00043C5.75195 7.20793 7.20695 5.75293 8.99945 5.75293C10.792 5.75293 12.247 7.20793 12.247 9.00043C12.247 10.7929 10.792 12.2479 8.99945 12.2479ZM8.99945 6.87793C7.82945 6.87793 6.87695 7.83043 6.87695 9.00043C6.87695 10.1704 7.82945 11.1229 8.99945 11.1229C10.1695 11.1229 11.122 10.1704 11.122 9.00043C11.122 7.83043 10.1695 6.87793 8.99945 6.87793Z'
                                    fill='#82858A'
                                  />
                                  <path
                                    d='M9.00055 15.7654C6.18055 15.7654 3.51805 14.1154 1.68805 11.2504C0.893047 10.0129 0.893047 7.99535 1.68805 6.75035C3.52555 3.88535 6.18805 2.23535 9.00055 2.23535C11.813 2.23535 14.4755 3.88535 16.3055 6.75035C17.1005 7.98785 17.1005 10.0054 16.3055 11.2504C14.4755 14.1154 11.813 15.7654 9.00055 15.7654ZM9.00055 3.36035C6.57805 3.36035 4.26055 4.81535 2.64055 7.35785C2.07805 8.23535 2.07805 9.76535 2.64055 10.6429C4.26055 13.1854 6.57805 14.6404 9.00055 14.6404C11.423 14.6404 13.7405 13.1854 15.3605 10.6429C15.923 9.76535 15.923 8.23535 15.3605 7.35785C13.7405 4.81535 11.423 3.36035 9.00055 3.36035Z'
                                    fill='#82858A'
                                  />
                                </svg>
                              </button>
                            </Link>

                            <button
                              className='btn border-0 dropdown-toggle'
                              data-bs-toggle='dropdown'
                              aria-expanded='false'
                              data-bs-popper-config='{"strategy":"fixed"}'
                            >
                              <svg
                                width='18'
                                height='18'
                                viewBox='0 0 18 18'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M7.49991 8.4705C7.49991 7.72933 8.0955 7.14697 8.82344 7.14697C9.55138 7.14697 10.147 7.74256 10.147 8.4705C10.147 9.19844 9.55138 9.79403 8.82344 9.79403C8.0955 9.79403 7.49991 9.21168 7.49991 8.4705Z'
                                  fill='#707070'
                                />
                                <path
                                  d='M7.49991 14.1175C7.49991 13.3763 8.0955 12.7939 8.82344 12.7939C9.55138 12.7939 10.147 13.3895 10.147 14.1175C10.147 14.8454 9.55138 15.441 8.82344 15.441C8.0955 15.441 7.49991 14.8587 7.49991 14.1175Z'
                                  fill='#707070'
                                />
                                <path
                                  d='M7.49991 2.82353C7.49991 2.08235 8.0955 1.5 8.82344 1.5C9.55138 1.5 10.147 2.09559 10.147 2.82353C10.147 3.55147 9.55138 4.14706 8.82344 4.14706C8.0955 4.14706 7.49991 3.56471 7.49991 2.82353Z'
                                  fill='#707070'
                                />
                              </svg>
                            </button>

                            <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                              <li className='dropdown-item'>
                                <Link to={`/admin/appraisals-admin/${data.id}`}>View Details</Link>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      ))}

                    {loading === false && appraisal?.length === 0 && (
                      <tr>
                        <td colSpan={7} className='text-center'>
                          No appraisal found
                        </td>
                      </tr>
                    )}
                    {loading === true && appraisal?.length === 0 && (
                      <tr>
                        <td colSpan={7} className='text-center'>
                          <HorizontalLoader></HorizontalLoader>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {paginationData.total > 0 && (
                <div className='pagination w-100 d-flex justify-content-center'>
                  <Pagination
                    className='pagination-bar ps-0'
                    currentPage={Number(paginationData.pageNumber)}
                    totalCount={paginationData.total}
                    pageSize={paginationData.pageSize}
                    onPageChange={(page: React.SetStateAction<number>) => setPage(page)}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <ModalWrapper
        showModal={showPayslipModal}
        closeModal={togglePayslipModal}
        title='Start New Appraisal'
      >
        <form onSubmit={handleSubmit(startAppraisal)}>
          <div className='form-group mb-3'>
            <label htmlFor='year-select'> Year</label>
            <select
              id='year-select'
              className='form-control'
              value={selectedYear}
              {...register('appraisalYear', {
                required: 'Year is required',
                onChange: (e) => setSelectedYear(parseInt(e.target.value)),
              })}
            >
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
            {errors.appraisalYear && (
              <small className='text-danger'>{errors.appraisalYear.message}</small>
            )}
          </div>

          <div className='form-group mb-3'>
            <label htmlFor='appraisalQuarter'>Quarter</label>

            <select
              {...register('appraisalQuarter', {
                required: 'Field is required',
              })}
              id='appraisalQuarter'
              className='form-control'
            >
              <option value='' disabled>
                -- Select --
              </option>
              <option value={1}>First Quarter</option>
              <option value={2}>Second Quarter</option>
              <option value={3}>Third Quarter</option>
              <option value={4}>Fourth Quarter</option>
            </select>
            {errors.appraisalQuarter && (
              <small className='text-danger'>{errors.appraisalQuarter.message}</small>
            )}
          </div>

          <div className='form-group mb-3'>
            <label htmlFor='appraisalStartingDate' className='ms-2'>
              Start Date
            </label>
            <input
              {...register('appraisalStartingDate', {
                required: 'Field is required',
              })}
              className='form-control'
              id='appraisalStartingDate'
              type='datetime-local'
            />
            {errors.appraisalStartingDate && (
              <small className='text-danger'>{errors.appraisalStartingDate.message}</small>
            )}
          </div>
          <div className='form-group mb-3'>
            <label htmlFor='appraisalClosingDate' className='ms-2'>
              End Date
            </label>
            <input
              {...register('appraisalClosingDate', {
                required: 'Field is required',
              })}
              className='form-control'
              id='appraisalClosingDate'
              type='datetime-local'
            />
            {errors.appraisalClosingDate && (
              <small className='text-danger'>{errors.appraisalClosingDate.message}</small>
            )}
          </div>

          {/* <div className='form-group mb-3 d-none'>
            <label htmlFor='appraisalClosingDate' className='ms-2'>
              Appraisal Open
            </label>
            <input
              {...register('appraisalClosingDate', {
                required: 'Field is required',
              })}
              className='form-control'
              id='appraisalClosingDate'
              type='datetime-local'
            />
            {errors.appraisalClosingDate && (
              <small className='text-danger'>{errors.appraisalClosingDate.message}</small>
            )}
          </div> */}

          <div className='form-group mb-3'>
            <button type='submit' className='btn btn-default btn-0'>
              Start Appraisal
              {request && <span className='spinner-border spinner-border-sm'></span>}
            </button>
          </div>
        </form>
      </ModalWrapper>
    </div>
  )
}

export default AppraisalsAdmin
